var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleGcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/GCP/Role1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.78552972,3.63636364 L4.54780362,3.63636364 L4.54780362,5.35353535 L6.9870801,5.35353535 C6.75968992,6.44444444 5.80878553,7.07070707 4.54780362,7.07070707 C3.05943152,7.07070707 1.86046512,5.8989899 1.86046512,4.44444444 C1.86046512,2.98989899 3.05943152,1.81818182 4.54780362,1.81818182 C5.18863049,1.81818182 5.76744186,2.04040404 6.22222222,2.4040404 L7.54521964,1.11111111 C6.73901809,0.424242424 5.70542636,0 4.54780362,0 C2.02583979,0 0,1.97979798 0,4.44444444 C0,6.90909091 2.02583979,8.88888889 4.54780362,8.88888889 C6.82170543,8.88888889 8.88888889,7.27272727 8.88888889,4.44444444 C8.88888889,4.18181818 8.84754522,3.8989899 8.78552972,3.63636364 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78552972,3.63636364 L4.54780362,3.63636364 L4.54780362,5.35353535 L6.9870801,5.35353535 C6.75968992,6.44444444 5.80878553,7.07070707 4.54780362,7.07070707 C3.05943152,7.07070707 1.86046512,5.8989899 1.86046512,4.44444444 C1.86046512,2.98989899 3.05943152,1.81818182 4.54780362,1.81818182 C5.18863049,1.81818182 5.76744186,2.04040404 6.22222222,2.4040404 L7.54521964,1.11111111 C6.73901809,0.424242424 5.70542636,0 4.54780362,0 C2.02583979,0 0,1.97979798 0,4.44444444 C0,6.90909091 2.02583979,8.88888889 4.54780362,8.88888889 C6.82170543,8.88888889 8.88888889,7.27272727 8.88888889,4.44444444 C8.88888889,4.18181818 8.84754522,3.8989899 8.78552972,3.63636364 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78552972,3.63636364 L4.54780362,3.63636364 L4.54780362,5.35353535 L6.9870801,5.35353535 C6.75968992,6.44444444 5.80878553,7.07070707 4.54780362,7.07070707 C3.05943152,7.07070707 1.86046512,5.8989899 1.86046512,4.44444444 C1.86046512,2.98989899 3.05943152,1.81818182 4.54780362,1.81818182 C5.18863049,1.81818182 5.76744186,2.04040404 6.22222222,2.4040404 L7.54521964,1.11111111 C6.73901809,0.424242424 5.70542636,0 4.54780362,0 C2.02583979,0 0,1.97979798 0,4.44444444 C0,6.90909091 2.02583979,8.88888889 4.54780362,8.88888889 C6.82170543,8.88888889 8.88888889,7.27272727 8.88888889,4.44444444 C8.88888889,4.18181818 8.84754522,3.8989899 8.78552972,3.63636364 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78552972,3.63636364 L4.54780362,3.63636364 L4.54780362,5.35353535 L6.9870801,5.35353535 C6.75968992,6.44444444 5.80878553,7.07070707 4.54780362,7.07070707 C3.05943152,7.07070707 1.86046512,5.8989899 1.86046512,4.44444444 C1.86046512,2.98989899 3.05943152,1.81818182 4.54780362,1.81818182 C5.18863049,1.81818182 5.76744186,2.04040404 6.22222222,2.4040404 L7.54521964,1.11111111 C6.73901809,0.424242424 5.70542636,0 4.54780362,0 C2.02583979,0 0,1.97979798 0,4.44444444 C0,6.90909091 2.02583979,8.88888889 4.54780362,8.88888889 C6.82170543,8.88888889 8.88888889,7.27272727 8.88888889,4.44444444 C8.88888889,4.18181818 8.84754522,3.8989899 8.78552972,3.63636364 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/GCP/Role1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F9FBFC",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uF807",
    transform: "translate(9.1249, 10.125)",
    fill: "#3267D6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8750714,6.80585921 C14.8750714,4.36761665 13.1844064,2.28320312 11.0578833,1.40820312 L9.62507096,3.88828158 L9.62507096,0.486171842 C9.62507096,0.216289163 9.4090555,0 9.13835254,0 L6.61178979,0 C6.34108642,0 6.12507096,0.216289163 6.12507096,0.486171842 L6.12507096,3.88773417 L4.69225862,1.4090234 C2.56573507,2.28320312 0.875070957,4.36679721 0.875070957,6.80585921 L0.87479767,8.75 L14.8747977,8.75 L14.8750714,6.80585921 L14.8750714,6.80585921 Z M15.7145248,9.89023471 C15.6461655,9.72890592 15.487572,9.625 15.3125714,9.625 L0.437571374,9.625 C0.263254968,9.625 0.105071274,9.7292347 0.03589162,9.88903141 C-0.0333155714,10.0496759 -0.000858636971,10.2360237 0.119618086,10.3631719 C0.192325024,10.4398434 1.96936795,12.25 7.85046217,12.25 C13.7315564,12.25 15.5094467,10.4401171 15.6051498,10.3632812 C15.7500714,10.2347653 15.7828842,10.0488281 15.7145248,9.89023471 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: 1534129544,
    transform: "translate(22.5556, 22.5551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FBBC05",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "-0.413436693 7.07070707 -0.413436693 1.81818182 3.10077519 4.44444444"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EA4335",
    fillRule: "nonzero",
    mask: "url(#mask-4)",
    points: "-0.413436693 1.81818182 3.10077519 4.44444444 4.54780362 3.21212121 9.50904393 2.42424242 9.50904393 -0.404040404 -0.413436693 -0.404040404"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#34A853",
    fillRule: "nonzero",
    mask: "url(#mask-6)",
    points: "-0.413436693 7.07070707 5.7881137 2.42424242 7.42118863 2.62626263 9.50904393 -0.404040404 9.50904393 9.29292929 -0.413436693 9.29292929"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4285F4",
    fillRule: "nonzero",
    mask: "url(#mask-8)",
    points: "9.50904393 9.29292929 3.10077519 4.44444444 2.27390181 3.83838384 9.50904393 1.81818182"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleGcp);
export default __webpack_public_path__ + "static/media/role-gcp.02f915e24ceafd09626ba645dac8f441.svg";
export { ForwardRef as ReactComponent };